(() => {
"use strict";
if (window.__gwInit) return; window.__gwInit = true;

const cfg = document.getElementById("gw-hero-cfg");
const VIDEO_URL = cfg ? (cfg.dataset.video || "") : "";
const POSTER_URI = cfg ? (cfg.dataset.poster || "") : "";
const ENDING_URI = cfg ? (cfg.dataset.ending || "") : "";

const rng = seed => { let s = seed >>> 0; return () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296; };
const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
const ss = (p, e0, e1) => { const t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };

document.querySelectorAll('[data-anim]').forEach(sec => {
  new IntersectionObserver((es, ob) => { if (es[0].isIntersecting) { sec.classList.add('in'); ob.disconnect(); } }, { threshold: 0.18 }).observe(sec);
});
document.addEventListener("visibilitychange", () => document.body.classList.toggle("paused", document.hidden));

const hero = document.getElementById("hero");
const stage = document.getElementById("stage");
const video = document.getElementById("hero-video");
const ring = document.getElementById("ring");
const posterlayer = document.getElementById("posterlayer");
const endinglayer = document.getElementById("endinglayer");
if (!hero || !stage || !video) return;

if (POSTER_URI) posterlayer.style.backgroundImage = `url("${POSTER_URI}")`;
if (ENDING_URI) endinglayer.style.backgroundImage = `url("${ENDING_URI}")`;

const bands = [...document.querySelectorAll(".band")].map(el => ({
  el, a: +el.dataset.a, b: +el.dataset.b, ent: el.dataset.ent, zone: el.dataset.zone,
  lastOp: -1, lastK: -1, on: false
}));
const SR = rng(77);
bands.forEach(band => {
  const t = band.el.querySelector(".split, .blurline");
  if (!t) return;
  const text = t.textContent;
  if (band.ent === "blur") {
    t.innerHTML = `<span class="vh">${text}</span><span class="stack" aria-hidden="true"><span class="soft">${text}</span><span class="sharp">${text}</span></span>`;
    return;
  }
  const words = text.split(" ");
  const total = text.replace(/ /g, "").length;
  let ci = 0, html = `<span class="vh">${text}</span><span aria-hidden="true">`;
  words.forEach((wd, wi) => {
    html += `<span class="w"${band.ent === "rise" ? ` style="--th:${(wi / words.length * 0.45).toFixed(3)}"` : ""}>`;
    for (const ch of wd) {
      let st = "";
      if (band.ent === "drift") st = `--th:${(SR() * 0.4).toFixed(3)}`;
      else if (band.ent === "grid") st = `--th:${(ci / total * 0.34 + SR() * 0.06).toFixed(3)};--jx:${(18 + SR() * 26).toFixed(0)}px`;
      else if (band.ent === "weave") st = `--th:${(ci / total * 0.3 + SR() * 0.08).toFixed(3)};--jy:${(ci % 2 ? 1 : -1) * (16 + SR() * 18) | 0}px`;
      else if (band.ent === "scatter") st = `--th:${(SR() * 0.5).toFixed(3)};--jx:${((SR() - 0.5) * 74) | 0}px;--jy:${((SR() - 0.5) * 58) | 0}px;--jr:${((SR() - 0.5) * 30) | 0}deg`;
      const cc = /\d/.test(ch) ? "c num" : "c";
      html += st ? `<span class="${cc}" style="${st}">${ch}</span>` : `<span class="${cc}">${ch}</span>`;
      ci++;
    }
    html += `</span>${wi < words.length - 1 ? " " : ""}`;
  });
  t.innerHTML = html + "</span>";
});

let videoReady = false, triedDirect = false;
function armVideo() {
  video.load();
  video.addEventListener("canplay", () => {
    if (videoReady) return;
    videoReady = true;
    ring.style.setProperty("--ld", 0);
    ring.classList.add("gone");
    requestSeek(shown * (video.duration || 10.042));
    stage.classList.add("video-ready");
  }, { once: true });
  video.addEventListener("error", failVideo);
}
async function loadVideo() {
  if (!VIDEO_URL) { ring.classList.add("gone"); return; }
  try {
    ring.style.setProperty("--ld", 110);
    const res = await fetch(VIDEO_URL);
    if (!res.ok) throw new Error("http " + res.status);
    const total = Number(res.headers.get("Content-Length")) || 7286378;
    const reader = res.body.getReader();
    const chunks = [];
    let got = 0, lastRing = 0;
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      chunks.push(value); got += value.length;
      const now = performance.now();
      if (now - lastRing > 100) { lastRing = now; ring.style.setProperty("--ld", Math.round(126 * (1 - Math.min(1, got / total)))); }
    }
    video.src = URL.createObjectURL(new Blob(chunks, { type: "video/mp4" }));
    armVideo();
  } catch (e) { failVideo(); }
}
function failVideo() {
  if (!triedDirect) {
    triedDirect = true;
    video.src = VIDEO_URL;
    armVideo();
    return;
  }
  ring.classList.add("gone");
}

let seekBusy = false, pendingTime = null, seekIssuedAt = 0;
function requestSeek(t) {
  if (!videoReady || !video.duration) return;
  t = clamp(t, 0, Math.max(0, video.duration - 0.05));
  if (seekBusy) {
    if (performance.now() - seekIssuedAt > 350) { seekBusy = false; }
    else { pendingTime = t; return; }
  }
  seekBusy = true;
  seekIssuedAt = performance.now();
  video.currentTime = t;
}
function seekDone() {
  if (!seekBusy) return;
  seekBusy = false;
  if (pendingTime !== null) { const t = pendingTime; pendingTime = null; requestSeek(t); }
}
video.addEventListener("seeked", seekDone);
video.addEventListener("timeupdate", seekDone);
video.addEventListener("error", () => { seekBusy = false; pendingTime = null; });

let target = 0, shown = 0, rafId = null, lastTick = 0, loadK = 0;
let heroOn = true, staticMode = false, scrubOn = false;
function heroProgress() {
  const r = hero.getBoundingClientRect();
  const total = r.height - innerHeight;
  return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
}
const depthEl = document.getElementById("depth"), zoneEl = document.getElementById("zone"), cueEl = document.getElementById("cue");
let lastHud = "", lastHudAt = 0, cueOff = false;
function render(p, now) {
  requestSeek(p * (video.duration || 10.042));
  for (const band of bands) {
    const len = band.b - band.a, f = Math.min(0.065, len / 2.5);
    let op;
    if (band.a === 0) op = 1 - ss(p, band.b - f, band.b);
    else if (band.b === 1) op = ss(p, band.a, band.a + f);
    else op = ss(p, band.a, band.a + f) * (1 - ss(p, band.b - f, band.b));
    let k = clamp((p - band.a) / Math.min(0.07, len * 0.5), 0, 1);
    if (band.a === 0) k = Math.max(k, loadK);
    if (Math.abs(op - band.lastOp) > 0.008 || band.lastOp < 0) { band.el.style.opacity = op.toFixed(3); band.lastOp = op; }
    if (Math.abs(k - band.lastK) > 0.008 || band.lastK < 0) { band.el.style.setProperty("--k", k.toFixed(3)); band.lastK = k; }
    const on = op > 0.01;
    if (on !== band.on) { band.el.classList.toggle("on", on); band.on = on; }
  }
  if (now - lastHudAt > 100 && depthEl) {
    const d = Math.round(p * 24);
    let zone = "SURFACE";
    for (const band of bands) if (p >= band.a - 0.02) zone = band.zone;
    const s = d + zone;
    if (s !== lastHud) { lastHud = s; lastHudAt = now; depthEl.textContent = d === 0 ? "0″" : "−" + d + "″"; zoneEl.textContent = zone; }
  }
  const co = p > 0.02;
  if (cueEl && co !== cueOff) { cueEl.classList.toggle("off", co); cueOff = co; }
}
function tick(now) {
  const dt = Math.min(100, now - (lastTick || now));
  lastTick = now;
  const k = 0.09;
  shown += (target - shown) * (1 - Math.pow(1 - k, dt / 16.667));
  if (Math.abs(target - shown) < 0.0004) { shown = target; rafId = null; lastTick = 0; }
  else rafId = requestAnimationFrame(tick);
  render(shown, now);
}
function onScroll() {
  target = heroProgress();
  if (rafId === null && heroOn) rafId = requestAnimationFrame(tick);
}
function runLoadRamp() {
  const t0 = performance.now();
  const step = now => {
    if (staticMode) return;
    const t = clamp((now - t0) / 1400, 0, 1);
    loadK = t * t * (3 - 2 * t);
    if (rafId === null) render(shown, now);
    if (t < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}

const GATES = [
  "(max-width: 720px)",
  "(orientation: portrait) and (max-width: 1024px)",
  "(orientation: portrait) and (pointer: coarse)",
  "(orientation: landscape) and (pointer: coarse) and (max-height: 560px)",
  "(prefers-reduced-motion: reduce)"
];
let videoRequested = false;
function enableScrub() {
  if (scrubOn) return; scrubOn = true; staticMode = false;
  if (!videoRequested) { videoRequested = true; setTimeout(loadVideo, 60); }
  addEventListener("scroll", onScroll, { passive: true });
  bands.forEach(b => { b.lastOp = -1; b.lastK = -1; });
  target = heroProgress(); shown = target;
  render(shown, performance.now());
  onScroll();
}
function disableScrub() {
  scrubOn = false; staticMode = true;
  removeEventListener("scroll", onScroll);
  if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
}
function applyHeroMode() { if (GATES.some(q => matchMedia(q).matches)) disableScrub(); else enableScrub(); }
const MQLS = GATES.map(q => matchMedia(q));
MQLS.forEach(m => m.addEventListener("change", applyHeroMode));

new IntersectionObserver(es => {
  heroOn = es[0].isIntersecting;
  if (heroOn && scrubOn) onScroll();
  if (!heroOn && rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
}).observe(hero);

applyHeroMode();
if (!staticMode) runLoadRamp();
})();
